/**
 * Simple-profile milestones — has the SP's own QR ever produced a connection?
 *
 * ONE stable key, written at the formation site (qrDetection) beside funnel
 * step 3, which is the same moment. Deliberately NOT read off the analytics
 * dedupe sentinels: those are per-room and belong to the event layer, and UI
 * that reads them silently breaks the day someone renames one.
 *
 * localStorage, never session: "my QR has worked at least once" is true for
 * good, and the reminder it retires must not come back next week.
 */
const HOSTED_KEY = 'sp_hosted_exchange';

export const markSimpleHostedExchange = () => {
  try {
    localStorage.setItem(HOSTED_KEY, 'true');
  } catch {
    // Storage unavailable (private mode) — the reminder simply stays, which is
    // the harmless direction to fail in.
  }
};

export const hasSimpleHostedExchange = () => {
  try {
    return localStorage.getItem(HOSTED_KEY) === 'true';
  } catch {
    return false;
  }
};
